export const iconStyle: React.CSSProperties = {
    height: "24px",
    width: "24px",
    opacity: 0.68,
    fill: "var(--color-greyDark1)",
  };


// WEBPACK FOOTER //
// ./src/icons/icon.style.ts